import { Breadcrumb, Button, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import QuotesApi from '../../../../api/Sales/Quotes'
import Amount from '../../../../components/Common/Amount'
import AddBudgetCont from '../../../../components/Common/Budgets/BudgetCont'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import PaymentTermsCont from '../../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTermsCont'
import { AddQuoteContext } from '../../../../components/Sales/Quotes/AddQuote/AddQuoteCont'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import withMapList from '../../../../elements/HOC/withMapList'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import IconText from '../../../../elements/IconText'
import LinkHeader from '../../../../elements/LinkHeader'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import Status from '../../../../elements/Status'
import _, { get, isEmpty } from 'lodash'
import Authentication from '../../../../modules/Authentication'
import { idMaker, numVal, strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { streamUrl } from '../../../../variables'
import History from '../../../Common/History'
import OrdersList from '../../Orders/OrdersList'
import style from '../../style.css'
import QuoteForm from './QuoteForm'
import QuoteLineModal from './QuoteLineModal'
import QuoteLinesList from './QuoteLinesList'
import EmailListCont from '../../../Main/Emails/EmailCont'

const { TabPane } = Tabs
const ids = idMaker()
const auth = new Authentication()
export const EnquiriesSelect = compose(
  withUrlFetch({
    name: 'activities',
    url: `enquiries/?select=code,_id,title`,
    cache: false,
  }),
  withSpinning,
  withMapList((enquiry) => ({
    ...enquiry,
    display: `${enquiry.code} - ${enquiry.title}`,
  })),
)(CustomSelect)

const QuoteApi = new QuotesApi()

function AddQuote (props) {
  const {
    isUpdatable,
    fetchingActions,
    type,
    lines,
    submitting,
    updating,
    fetching,
    ServicesSelectCmp,
    onChangeEnquiry,
    submit,
    fetch,
    update,
    formRef,
    actions,
    quote,
    handleActions,
    showEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
    enquiry,
    fetchingEnquiry,
  } = React.useContext(AddQuoteContext)

  const { data: listSalesOrder, fetching: fetchingSalesOrder, fetchURL: fetchSalesOrder } = useFetchURL(
    `foxxapi/sales?select=*&quote=${quote._key}`,
    [quote._key],
    isEmpty(quote._key),
    undefined,
    true,
  )

  const Operations = ({ quote, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && quote.status === 'Confirmed') {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }

    quote.status !== 'Confirmed' &&
    ops.push(
      <a target={'_blank'} href={`${streamUrl}pdf/${quote._id}?access_token=${auth.getAccessToken()}`}>
        <IconText text={'PDF preview'} type={'file-pdf'}/>
      </a>,
    )
    quote.status === 'Confirmed' &&
    ops.push(
      <a onClick={showEmail}>
        <IconText text={'Email Issuance'} type={'mail'}/>
      </a>,
    )
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <Button
      style={{ float: 'right', marginBottom: 10 }}
      icon={'form'}
      loading={updating || submitting}
      type="primary"
      onClick={type !== 'edit' ? submit : update}>
      {type === 'edit' ? 'Apply Changes' : 'Submit'}
    </Button>
  )
  const isNew = type === 'new'
  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <LinkHeader
        title={'Quotation'}
        link={{
          pathname: `/clients/enquiries/${_.get(quote, 'enquiry._id', '').replace('activities/', '')}/update`,
        }}
        code={_.get(quote, 'enquiry.code')}
        name={_.get(quote, 'enquiry.title')}
        visible={!_.isEmpty(_.get(quote, 'enquiry'))}
      />
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/clients/quotes/`}>Quotes</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New Quote' : quote.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Quote</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="Quote Code">{strVal(quote, 'code')}</Tooltip>
                  </h2>
                  <Status value={strVal(quote, 'status')}/>
                  <Operations style={{ marginTop: '10px' }} quote={quote} status={strVal(quote, 'status')}/>
                </h3>
              </Col>
              <Col span={5}>
                <Amount
                  data={[
                    { name: 'SUB-TOTAL', amount: numVal(quote, 'subTotal.net') },
                    { name: 'TAX', amount: get(quote,'taxType') !== 'ex-tax' ? numVal(quote, 'subTotal.tax'): 0 },
                    { name: 'TOTAL', amount: get(quote,'taxType') !== 'ex-tax' ? numVal(quote, 'subTotal.gross') : numVal(quote, 'subTotal.net') },
                  ]}
                  currency={quote.currency}
                />
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}

          {type === 'new' && (
            <>
              <p className={style.paragraph}>Create a new quote</p>
            </>
          )}
        </Row>
      </Card>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#details'} onChange={(key) => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle"/>
                Details
              </span>
            }
            key="#details">
            {(isUpdatable || isNew) && (
              <Row>
                <SubmitButton/>
              </Row>
            )}
            <QuoteForm isUpdatable={isUpdatable} ref={formRef}/>
            {(isUpdatable || isNew) && (
              <Row>
                <SubmitButton/>
              </Row>
            )}
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list"/> Client Payment Terms
              </span>
            }
            key="#payment-terms">
            <PaymentTermsCont owner={quote} isUpdatable={isUpdatable}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list"/> Quotation Lines
              </span>
            }
            key="#lines">
            <QuoteLineModal ServicesSelectCmp={ServicesSelectCmp}/>
            <QuoteLinesList/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="credit-card"/>
                Cost Budget
              </span>
            }
            key="#budgets">
            <AddBudgetCont loading={fetching} onCancel={fetch} owner={quote}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="dollar"/>
                Sales Order
              </span>
            }
            key="#sales">
            <OrdersList
              enquiryID={enquiry._id}
              quoteID={quote._id}
              fetching={fetchingSalesOrder}
              fetch={fetchSalesOrder}
              list={listSalesOrder}
              hideCompany={true}
            />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="copy"/>
                History
              </span>
            }
            key="#history">
            <History loading={fetching} owner={quote}/>
          </TabPane>
          <TabPane tab="Email" key="#email">
            <EmailListCont owner={quote._id} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="folder-open"/>
                Documents
              </span>
            }
            key="#docs">
            <DocumentsCont email={true} emailLabel={'Email with Quote'} owner={quote}/>
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

AddQuote.propTypes = {}
AddQuote.defaultProps = {}

export default withRouter(AddQuote)
